import React, { useEffect, useState } from "react";
import { anggaranPemasukanTable } from "./anggaranPemasukanTable";
import { anggaranPemasukanFormData } from "./anggaranPemasukanFormData";
import { anggaranPemasukanFilter } from "./anggaranPemasukanFilterData";

// API
import {
  getAllDataTableAnggaranPemasukan,
  getDropdownTahunAnggaranPemasukan,
  getFilteredAnggaranPemasukan,
  insertAnggaranPemasukan,
  updateAnggaranPemasukan,
  deleteAnggaranPemasukan,
} from "./api/anggaranPemasukanAPI";
import { getDropdownAkuns } from "../kodeAkun/api/kodeAkunAPI";
import { getDropdownUnitUsaha } from "../unitUsaha/api/unitUsahaAPI";

// Component
import CardTable from "components/Cards/CardTable";
import FormCustom from "components/Forms/FormCustom";
import ConfirmModal from "components/Modal/ConfirmModal";

import toast, { Toaster } from "react-hot-toast";
import { useHistory } from "react-router";
import { getDropdownTahunValue } from "../dataTahun/api/dataTahunAPI";
import ShowDetailModal from "components/Modal/ShowDetailModal";

export default function AnggaranPemasukan() {
  const history = useHistory();

  const [addForm, setAddForm] = useState(false);
  const [editForm, setEditForm] = useState(false);
  const [editFormValue, setEditFormValue] = useState(null);

  const [dataTable, setDataTable] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [active, setActive] = useState(false);

  const [formData, setFormData] = useState(null);

  // Select-Option Data
  const [dropdownTahunAnggaran, setDropdownTahunAnggaran] = useState([]);
  const [dropdownUnitUsaha, setDropdownUnitUsaha] = useState([]);
  const [dropdownAkuns, setDropdownAkuns] = useState([]);
  const [dropdownTahun, setDropdownTahun] = useState([]);

  // Type Search
  const [typeSearch, setTypeSearch] = useState("");

  // Filter Data
  const [filterData, setFilterData] = useState(null);

  // Filter Data Arr
  const [filterDataArr, setFilterDataArr] = useState([]);

  const [formDataArr, setFormDataArr] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  const [deletePopUp, setDeletePopUp] = useState([{ show: false, id: null }]);
  const [showDetailPopUp, setShowDetailPopUp] = useState({
    show: false,
    id: null,
    data: null,
  });

  // Component is Active ?
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  // handle when state active changed
  useEffect(() => {
    setIsLoading(true);

    getAllDataTableAnggaranPemasukan()
      .then((response) => {
        active === true && setDataTable(response.data.data);
      })
      .catch((error) => console.error(`Error: ${error}`))
      .finally(setIsLoading(false));

    return () => {
      setDataTable([]);
    };
  }, [active]);

  // Select-Option Data
  // Load Dropdown Tahun
  useEffect(() => {
    setIsLoading(true);

    getDropdownTahunValue()
      .then((response) => {
        setDropdownTahun(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));
  }, [active]);

  // Load Dropdown Tahun Anggaran Pemasukan
  useEffect(() => {
    setIsLoading(true);

    getDropdownTahunAnggaranPemasukan()
      .then((response) => {
        setDropdownTahunAnggaran(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownTahunAnggaran([]);
    };
  }, [active]);

  // Load Dropdown Unit Usaha
  useEffect(() => {
    setIsLoading(true);

    getDropdownUnitUsaha()
      .then((response) => {
        setDropdownUnitUsaha(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownUnitUsaha([]);
    };
  }, [active]);

  // Load Dropdown Akuns
  useEffect(() => {
    setIsLoading(true);

    getDropdownAkuns()
      .then((response) => {
        setDropdownAkuns(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownAkuns([]);
    };
  }, [active]);

  // End Select-Option Data

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(
      anggaranPemasukanFormData(dropdownUnitUsaha, dropdownAkuns, dropdownTahun)
    );

    return () => {
      setFormDataArr([]);
    };
  }, [dropdownUnitUsaha, dropdownAkuns, dropdownTahun]);

  // Load Filter Data Arr
  useEffect(() => {
    setFilterDataArr(
      anggaranPemasukanFilter(dropdownTahunAnggaran, dropdownUnitUsaha)
    );

    return () => {
      setFilterDataArr([]);
    };
  }, [dropdownTahunAnggaran, dropdownUnitUsaha]);

  // Clear Form Data When First Time Load Component
  useEffect(() => {
    setFormData(null);
  }, [active]);

  // Handle When User Click Add Button
  function handleInsert() {
    setActive(false);
    setAddForm(true);
  }

  // Handle When User Click Cancel Button
  const handleCancelButton = () => {
    setAddForm(false);
    setEditForm(false);
    setEditFormValue(null);
    setFormData(null);
    setActive(true);
  };

  // Handle When User Click Edit Button
  const handleEdit = (rowData) => {
    setActive(false);
    console.log(rowData);
    setEditFormValue({
      ...rowData,
      id_sistem_akun: rowData?.nama_akun,
      id_unit_usaha: rowData?.unit_usaha,
    });
    setEditForm(true);
  };

  // Handle When User Click Delete Button
  const handleDelete = (rowData) => {
    setDeletePopUp({
      show: true,
      id: rowData.id_anggaran_pemasukan,
    });
  };

  // Handle When User Confirm to Delete Data
  const handleDeleteTrue = () => {
    setActive(false);
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deleteAnggaranPemasukan(deletePopUp.id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }
  };

  // Handle When User Deny to Confirm Delete Data
  const handleDeleteFalse = () => {
    setDeletePopUp({
      show: false,
      id: null,
    });
  };

  // Handle when user click show detail button
  function handleShowDetail(rowData) {
    setShowDetailPopUp({
      show: true,
      id: rowData.id_anggaran_pemasukan,
      data: rowData,
    });
  }

  // Handle when user want to Close show detail modal
  const handleCloseShowDetail = () => {
    setShowDetailPopUp({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle When User Submit New Data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    insertAnggaranPemasukan(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(endSubmitProcess());
  };

  // Handle When User Submit Update Data
  const handleUpdateSubmit = (e) => {
    e.preventDefault();
    if (formData !== null) {
      const id = editFormValue.id_anggaran_pemasukan;

      setIsLoading(true);

      updateAnggaranPemasukan(formData, id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    } else {
      toast.error(`Tidak ada data yang di ubah.`);
    }
  };

  // Check If Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  // Check if Request Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setFormData(null);
        setAddForm(false);
        setEditForm(false);
        setActive(true);
        history.push("/masterData/anggaranPemasukan");
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray.length > 0) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);
    }
    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Set Inputed Data to Form
  const setData = (key, value) => {
    return setFormData({ ...formData, [key]: value });
  };

  // Set Inputed Data Filter to State filterData
  const setDataFilter = (key, value) => {
    return setFilterData({ ...filterData, [key]: value });
  };

  // Handle When Submit Process End
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });
    setIsLoading(false);
  };

  // Handle when User Click Button Filter Data
  const handleFilter = () => {
    if (filterData !== null) {
      getFilteredAnggaranPemasukan(filterData)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    }
  };

  // Handle when User Click Button Reset Filter Data
  const handleResetFilter = () => {
    setFilterData(null);
    getAllDataTableAnggaranPemasukan()
      .then((response) => {
        setDataTable(response.data.data);
      })
      .catch((error) => console.error(`Error: ${error}`))
      .finally(setIsLoading(false));
    setPageNumber(0);
  };

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  // Handle when Searching Changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getAllDataTableAnggaranPemasukan(typeSearch)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getAllDataTableAnggaranPemasukan()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [typeSearch]);

  // Handle When Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              // getData = {getData}
              editFormValue={null}
            />
          </div>
        </div>
      </div>
    );

  if (editForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Edit Data"}
              formDataArr={formDataArr}
              handleSubmit={handleUpdateSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              editFormValue={editFormValue}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {deletePopUp.show && (
            <div>
              <ConfirmModal
                handleIfTrue={(e) => handleDeleteTrue()}
                handleIfFalse={(e) => handleDeleteFalse()}
              />
            </div>
          )}
          {showDetailPopUp.show && (
            <div>
              <ShowDetailModal
                handleClose={(e) => handleCloseShowDetail()}
                detailData={showDetailPopUp.data}
              />
            </div>
          )}
          <Toaster />
          <CardTable
            tableTitle="Tabel Master Anggaran Pemasukan"
            cols={anggaranPemasukanTable(
              handleEdit,
              handleDelete,
              handleShowDetail
            )}
            handleInsert={(e) => handleInsert()}
            handleSearch={handleSearch}
            data={dataTable}
            pageNumber={pageNumber}
            changePage={changePage}
            handleFilter={(e) => handleFilter()}
            handleResetFilter={(e) => handleResetFilter()}
            filterDataArr={filterDataArr}
            setDataFilter={setDataFilter}
          />
        </div>
      </div>
    </div>
  );
}
